/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Proname1Inputs */

const zh_pricing_proname1 = /** @type {(inputs: Pricing_Proname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const en_pricing_proname1 = /** @type {(inputs: Pricing_Proname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_pricing_proname1 = /** @type {(inputs: Pricing_Proname1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {Pricing_Proname1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_proname1 = /** @type {((inputs?: Pricing_Proname1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Proname1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_proname1(inputs)
	if (locale === "en") return en_pricing_proname1(inputs)
	return es_pricing_proname1(inputs)
});
export { pricing_proname1 as "pricing_proName" }